/* eslint-disable */
import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
// core components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import Table from "components/Table/Table.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Chip from "@material-ui/core/Chip";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InfoBox from "../../components/InfoIcon/InfoIcon";

// Dialog components
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

import { API_POST, API_UPLOAD } from "../../services/api.service";
import { FormGroup } from "@material-ui/core";

import FilesList from "./FilesList";
const { REACT_APP_SERVER_URL } = process.env;

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0",
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF",
    },
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1",
    },
  },
  searchOption: {
    background: "#ffffff 0% 0% no-repeat padding-box",
    boxShadow: "0px 6px 6px #00000029",
    zIndex: "1",
    position: "absolute",
    borderRadius: "16px",
    padding: "18px 6px 18px 12px",
    width: "100%",
    "& ul": {
      listStyleType: "none",
      maxHeight: "220px",
      overflowY: "auto",
      overflowX: "hidden",
      paddingRight: "9px",
      "& p": {
        textAlign: "left",
        font: "normal normal normal 12px/16px Roboto",
        letterSpacing: "0px",
        color: "#000000",
        marginBottom: "3px",
      },
      "& span": {
        font: "normal normal normal 12px/16px Roboto",
        letterSpacing: "0px",
        color: "#808080",
        cursor: "pointer",
      },
    },
  },
  searchExpand: {
    width: "175px!important",
    backgroundColor: "#fff",
    borderColor: "#707070",
    backgroundPosition: "95% center !important",
    WebkitBoxShadow: "0px 6px 6px #00000029",
    MozBoxShadow: "0px 6px 6px #00000029",
    BoxShadow: "0px 6px 6px #00000029",
  },
  dialogPaper: {
    minWidth: '500px',
    padding: '20px'
  }
};

const fileSizeLimit = 50 * 1024 * 1024;

class Files extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      campaignList: [],
      activeTab: 0,
      FileName: "",
      prospectsFields: [],
      headerfields: [],
      IsShowUploadheader: false,
      selectedFile: null,
      searchInput: "",
      SearchText: [],
      selectValue: [],
      mappingobj: {},
      SuggestionShow: false,
      UploadFileId: "",
      IsChecked: false,
      IsCheckedCampain: false,
      IsCheckedMakeFresh: false,
      IsOpenUpdateProspect: false,
      confirmDialogOpen: false,
             // New state for field creation popup
       newFieldDialogOpen: false,
       newFieldName: "",
       newFieldType: "text",
       currentEditingHeader: "",
      notify: {
        open: false,
        message: "",
        color: "success",
      },
    };
  }

  handleDialogOpen = () => {
    this.setState({ confirmDialogOpen: true });
  };

  handleDialogClose = () => {
    this.setState({ confirmDialogOpen: false });
  };

  // New field dialog handlers
  handleNewFieldDialogOpen = (headerName) => {
    this.setState({ 
      newFieldDialogOpen: true,
      newFieldName: "",
      newFieldType: "text",
      currentEditingHeader: headerName
    });
  };

  handleNewFieldDialogClose = () => {
    this.setState({ 
      newFieldDialogOpen: false,
      newFieldName: "",
      newFieldType: "text",
      currentEditingHeader: ""
    });
  };

  handleNewFieldNameChange = (event) => {
    this.setState({ newFieldName: event.target.value });
  };

  handleNewFieldTypeChange = (event) => {
    this.setState({ newFieldType: event.target.value });
  };

  handleSaveNewField = async () => {
    const { newFieldName, newFieldType } = this.state;
    
    if (!newFieldName.trim()) {
      this.setState({
        notify: {
          open: true,
          message: "Please enter a field name",
          color: "danger",
        },
      });
      return;
    }

    // Create new field object
    const newField = {
      field_name: newFieldName.trim(),
      field_type: newFieldType,
      is_custom: true,
      inUpload: true  // Ensure new fields appear in upload dropdown
    };

    // Save to database first
    await this.SaveHeaderInProspectCollection([newFieldName.trim()]);

    // Add to prospectsFields and auto-select the new field
    this.setState(prevState => {
      const updatedProspectsFields = [...prevState.prospectsFields, newField];
      
      // Find the current header that triggered the "Add Field" selection
      const currentHeader = prevState.currentEditingHeader;
      let updatedSelectValue = [...prevState.selectValue];
      
      // Update the selectValue to include the new field
      const existingIndex = updatedSelectValue.findIndex(item => 
        Object.keys(item)[0] === currentHeader
      );
      
      if (existingIndex !== -1) {
        updatedSelectValue[existingIndex] = { [currentHeader]: newFieldName.trim() };
      } else {
        updatedSelectValue.push({ [currentHeader]: newFieldName.trim() });
      }
      
      return {
        prospectsFields: updatedProspectsFields,
        selectValue: updatedSelectValue,
        newFieldDialogOpen: false,
        newFieldName: "",
        newFieldType: "text",
        currentEditingHeader: ""
      };
    });

    this.setState({
      notify: {
        open: true,
        message: `New field "${newFieldName}" added successfully`,
        color: "success",
      },
    });
  };

  handleConfirmContinue = async () => {
    this.handleDialogClose();
    const selectValue = this.state.selectValue.map(
      option => Object.values(option)[0]
    );
    const prospectsFields = this.state.prospectsFields.map(
      option => option.field_name
    );
    const filteredSelectValue = selectValue.filter(n => !prospectsFields.includes(n));
    
    await this.SaveHeaderInProspectCollection(filteredSelectValue);
    await this.SaveMappingCollection();
  };

  handleUpload = (evt) => {
    let selectedFile = evt.target.files[0];
    if (selectedFile.size > fileSizeLimit) {
      this.setState({
        notify: {
          open: true,
          message: "File size exceeds 50 MB",
          color: "danger",
        },
      });
      return;
    }

    this.setState({ FileName: selectedFile.name, selectedFile: selectedFile });
  };

  openUploadDialog = () => {
    if (!this.state.selectedFile) {
      this.setState({
        notify: {
          open: true,
          message: "Please select valid file ",
          color: "danger",
        },
      });
    } else {
      const { user, cid } = this.props;
      let data = new FormData();
      data.append("name", this.state.FileName);
      data.append("cid", cid);
      data.append("user", user && user.admin);
      data.append(
        "myFile",
        this.state.selectedFile,
        this.state.selectedFile.name,
        user && user.admin
      );

      this.UploadFile(data);
    }
  };

  async UploadFile(data) {
    let fileupload = await API_UPLOAD(`files/action/uploadFile`, data);
    if (fileupload.success) {
      let fileHeaders = fileupload.data.headers[0].data[0];
      let prospectsFields = fileupload.data.Mongodata;
      let option = prospectsFields.map((option) => option.field_name);
      let compareOption = prospectsFields.map((option) =>
        option.field_name && option.field_name.toLowerCase()
      );
      
      let selectValue = [];
      for (let index = 0; index < fileHeaders.length; index++) {
        const element = fileHeaders[index];
        if (element) {
          let compareIndex = compareOption.indexOf(element.toLowerCase());
          if (compareIndex > -1) {
            selectValue.push({ [element]: option[compareIndex] });
          }
        }
      }

      this.setState({ 
        headerfields: fileHeaders,
        prospectsFields: prospectsFields,
        UploadFileId: fileupload.data.fileId,
        IsShowUploadheader: true,
        selectValue: selectValue
      });
    } else {
      this.setState({
        notify: {
          open: true,
          message: fileupload.msg,
          color: "danger",
        },
      });
    }
  }

  handleChange = (i, val, e) => {
    let field = e.target.value;
    console.log("dddddddddd",field,this.state.selectValue,this.state.headerfields)
    
    // Check if "Other" is selected to open the new field dialog
    if (field === "Add Field") {
      this.handleNewFieldDialogOpen(val);
      return;
    }
    
    if (!field) return;

    let { selectValue } = this.state;
    let IsExist = false;
    
    selectValue = selectValue.map(item => {
      if (val === Object.keys(item)[0]) {
        IsExist = true;
        return { [val]: field };
      }
      return item;
    });

    console.log("selectValue",val,IsExist);
    if (!IsExist) selectValue.push({ [val]: field });
    this.setState({ selectValue });
  };

  SaveHeaderInProspectCollection = async (selectValue) => {
    const { user } = this.props;
    for (let i = 0; i < selectValue.length; i++) {
      let element = selectValue[i];
      if (element) {
        await API_POST("files/action/upsert", {
          root: "prospect_fields",
          body: {
            display_Name: element,
            field_name: element,
            createdOn: new Date(),
            field_type: "text",
            isRequired: false,
            inTabView: false,
            inUpload: false,  // Ensure new fields are available in upload
            source: "custom",
            inUpload: true,
            field_options: "",
            is_custom: true
          },
          querydata: { field_name: element, admin: user && user.admin },
        });
      }
    }
  };

  SaveMappingCollection = async () => {
    const { user } = this.props;
    await API_POST("files/action/update", {
      root: "filesCollection",
      body: { Mapping: this.state.selectValue },
      querydata: { _id: this.state.UploadFileId },
    });

    const registerRequest = await API_POST("files/action/UploadExcelInDB", {
      fileId: this.state.UploadFileId,
      user: user && user.admin,
      IsCheckedCampain: this.state.IsCheckedCampain,
      IsCheckedMakeFresh: this.state.IsCheckedMakeFresh,
      IsOpenUpdateProspect: this.state.IsOpenUpdateProspect
    });

    if (registerRequest && registerRequest.status == 200) {
      if (registerRequest.data && registerRequest.data.err) {
        this.setState({
          notify: {
            open: true,
            message: registerRequest.data.msg,
            color: "danger",
          },
        });
        this.handleCancel();
        return;
      }

      this.setState({
        notify: {
          open: true,
          message: "We are updating your data! Please wait...",
          color: "success",
        },
      });
      this.handleCancel();
    }
  };

  Validitation = () => {
    let selectValue = this.state.selectValue.map(
      (option) => Object.values(option)[0]
    );

    if (
      selectValue &&
      selectValue.length > 0 &&
      (selectValue.indexOf("phone") == -1 && selectValue.indexOf("Phone") == -1)
    ) {
      return "phone number field is mandatory.";
    }
    return true;
  };

  handleAdd = async () => {
    let isValid = this.Validitation();
    if (isValid === true) {
      let selectValue = this.state.selectValue.map(
        (option) => Object.values(option)[0]
      );
      let prospectsFields = this.state.prospectsFields.map(
        (option) => option.field_name
      );
      let filteredSelectValue = selectValue.filter(n => !prospectsFields.includes(n));

      console.log("selectValue",selectValue,prospectsFields,filteredSelectValue);
      console.log("this.state.headerfields",this.state.headerfields);   

      if (
        selectValue.length !== this.state.headerfields.length ||
        selectValue.some(v => v === "" || v === null || v === undefined)
      ) {
        this.handleDialogOpen();
      } else {
        await this.SaveHeaderInProspectCollection(filteredSelectValue);
        await this.SaveMappingCollection();
      }
    } else {
      this.setState({
        notify: {
          open: true,
          message: isValid,
          color: "danger",
        },
      });
    }
  };

  handleCancel = () => {
    this.setState({ IsShowUploadheader: false });
  };

  handleRefresh = () => {
    window.location.reload();
  };

  RebindHeader = (data, row) => {
    let option = data.prospectFields.map((option) => option.field_name);
    let compareOption = data.prospectFields.map((option) =>
      option.field_name.toLowerCase()
    );
    let selectValue = [];
    
    for (let index = 0; index < data.headers.length; index++) {
      const element = data.headers[index];
      if (element) {
        let compareIndex = compareOption.indexOf(element.toLowerCase());
        if (compareIndex > -1) {
          selectValue.push({ [element]: option[compareIndex] });
        }
      }
    }
    
    this.setState({
      UploadFileId: row._id,
      IsShowUploadheader: true,
      headerfields: data.headers,
      prospectsFields: data.prospectFields,
      selectValue: selectValue
    });
  };

  handleCheck = (event) => {
    let checked = event.target.checked;
    this.setState({ IsChecked: checked, IsCheckedCampain: checked });
  };

  handleFreshCheck = (event) => {
    let checked = event.target.checked;
    this.setState({ IsCheckedMakeFresh: checked });
  };

  handleOpenProspect = (event) => {
    let checked = event.target.checked;
    this.setState({ IsOpenUpdateProspect: checked });
  };

  render() {
    const defaultInUploadFields = ["FirstName","firstName","lastName","phone","email","address","city","state","pincode","source","assignTo"]
    .map(field => field.toLowerCase());
  
    const { user, cid, campaignsDetails, classes } = this.props;
    let options = this.state.prospectsFields.filter(option => { return (option.inUpload || defaultInUploadFields.includes(option.field_name.toLowerCase()))}).map(
      (option) => option.field_name
    );
    //options = options.filter(option =>{ return (option.inUpload || defaultInUploadFields.includes(option.toLowerCase()))});
    // Add "Other" option to the end
    console.log("options..............",options);
    const optionsWithOther = [...options, "Add Field"];
    const compareOptions = this.state.prospectsFields.map((option) =>
      option.field_name.toLowerCase()
    );

    var tableData = [];
    for (let index = 0; index < this.state.headerfields.length; index++) {
      const element = this.state.headerfields[index];
      if (element) {
        let compareIndex = compareOptions.indexOf(element.toLowerCase());
        tableData.push([
          element,
          <FormGroup>
            <Select
              value={(() => {
                const existingMapping = this.state.selectValue.find(item => 
                  Object.keys(item)[0] === element
                );
                return existingMapping ? Object.values(existingMapping)[0] : "";
              })()}
              onChange={this.handleChange.bind(this, index, element)}
              displayEmpty
              variant="filled"
              fullWidth
            >
              <MenuItem value="">
                <em>Select a field</em>
              </MenuItem>
              {optionsWithOther.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormGroup>,
        ]);
      }
    }

    return (
      <>
        <Snackbar
          place="tr"
          color={this.state.notify.color}
          message={this.state.notify.message}
          open={this.state.notify.open}
          autoHideDuration={3000}
          closeNotification={() =>
            this.setState({
              notify: {
                open: false,
              },
            })
          }
          close
        />

        <Dialog
          open={this.state.confirmDialogOpen}
          onClose={this.handleDialogClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          classes={{ paper: classes.dialogPaper }}
        >
          <DialogTitle id="alert-dialog-title">{"Confirm Action"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Headers Mapping is not completed. The prospects fields will be assigned to the header name.
              Do you want to continue?
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDialogClose} color="primary">
              Cancel
            </Button>
            <Button onClick={this.handleConfirmContinue} color="primary" autoFocus>
              Continue
            </Button>
          </DialogActions>
        </Dialog>

                 {/* New Field Creation Dialog */}
         <Dialog
           open={this.state.newFieldDialogOpen}
           onClose={this.handleNewFieldDialogClose}
           aria-labelledby="new-field-dialog-title"
           classes={{ paper: classes.dialogPaper }}
         >
           <DialogTitle id="new-field-dialog-title">{"Create New Field"}</DialogTitle>
           <DialogContent>
             <DialogContentText>
               Add a new custom field to the system
             </DialogContentText>
             <TextField
               autoFocus
               margin="dense"
               id="field-name"
               label="Field Name"
               type="text"
               fullWidth
               variant="outlined"
               value={this.state.newFieldName}
               onChange={this.handleNewFieldNameChange}
               style={{ marginBottom: '20px' }}
             />
             <TextField
               select
               margin="dense"
               id="field-type"
               label="Field Type"
               fullWidth
               variant="outlined"
               value={this.state.newFieldType}
               onChange={this.handleNewFieldTypeChange}
             >
               <option value="text">Text</option>
               <option value="datetime">dateTime</option>
               <option value="number">Number</option>
               <option value="email">Email</option>
             </TextField>
           </DialogContent>
           <DialogActions>
             <Button onClick={this.handleNewFieldDialogClose} color="primary">
               Cancel
             </Button>
             <Button onClick={this.handleSaveNewField} color="success" autoFocus>
               Save Field
             </Button>
           </DialogActions>
         </Dialog>

        {/* Show upload functionality */}
        {!this.state.IsShowUploadheader && (
          <GridContainer>
            {cid && (
              <GridItem sm={12} md={12} xs={12}>
                <h5>
                  <GridItem style={{ float: "right", marginTop: "-20px" }}>
                    <InfoBox name={'Campaigns.ViewMore.Files'} />
                  </GridItem>
                  <ul>
                    <li>
                      <b> Note</b> :Please do not use special charactors and
                      space in column names, <b>phone</b> is manadatory while uploading database.
                    </li>
                    <li>
                      <b> Note</b> :Please use <b>CountryCode</b> while
                      uploading International Phone Numbers. By Default, we are
                      using <b>Indian standard </b>. <br />For reference  &nbsp;
                      <a href={"/CountryCode.csv"}>CountryCode List</a>&nbsp;
                      is attached.
                    </li>
                  </ul>
                </h5>

                <GridContainer>
                  <GridItem xs={12} sm={12} md={12}>
                    <ol>
                      <li>
                        <span>
                          <input
                            type="checkbox"
                            name="Campaign"
                            value={"IsFilter"}
                            checked={this.state.IsChecked}
                            onChange={(event) => {
                              this.handleCheck(event);
                            }}
                          />
                          Duplicate records to be pulled in campaign?
                        </span>
                      </li>
                      <li>
                        <span>
                          <input
                            type="checkbox"
                            name="IsCheckedMakeFresh"
                            value={"IsCheckedMakeFresh"}
                            checked={this.state.IsCheckedMakeFresh}
                            onChange={(event) => {
                              this.handleFreshCheck(event);
                            }}
                          />
                          Set all the prospects as fresh prospect.
                        </span>
                      </li>
                      <li>
                        <span>
                          <input
                            type="checkbox"
                            name="IsOpenUpdateProspect"
                            value={"IsOpenUpdateProspect"}
                            checked={this.state.IsOpenUpdateProspect}
                            onChange={(event) => {
                              this.handleOpenProspect(event);
                            }}
                          />
                          Low call priority in case of duplicate updation.
                        </span>
                      </li>
                    </ol>
                  </GridItem>

                  <GridItem xs={12} sm={12} md={12}>
                    <input
                      type="file"
                      accept=".csv,.xlsx"
                      onChange={(e) => {
                        this.handleUpload(e);
                      }}
                    />

                    <Button
                      size="sm"
                      onClick={() => {
                        this.openUploadDialog();
                      }}
                    >
                      Upload
                    </Button>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={12}>
                    <a href={"/SampleSheet.xlsx"}>Sample Sheet</a>
                  </GridItem>
                </GridContainer>
              </GridItem>
            )}
            <GridItem sm={12} md={12} xs={12}>
              <FilesList
                user={user}
                cid={cid}
                RebindHeader={this.RebindHeader}
                campaignsDetails={campaignsDetails}
              />
            </GridItem>
          </GridContainer>
        )}

        {/* Show Data for mapping */}
        {this.state.IsShowUploadheader && (
          <GridContainer>
            <GridItem xs={12} sm={6} md={6}>
              <Card>
                <CardHeader>Data</CardHeader>
                <CardBody>
                  <Table
                    tableHeaderColor="primary"
                    tableHead={["File Header", "System fields"]}
                    tableData={tableData}
                  />
                  <Button
                    color="success"
                    size="sm"
                    onClick={() => this.handleAdd()}
                  >
                    Save
                  </Button>
                  <Button
                    color="success"
                    size="sm"
                    onClick={() => this.handleCancel()}
                  >
                    Cancel
                  </Button>
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        )}
      </>
    );
  }
}

export default withStyles(styles)(Files);